export default __webpack_public_path__ + "static/media/aes-logo.b2a5714a.svg";